import { combineReducers } from "@reduxjs/toolkit";

import {
	customersAgentsDataModalState,
	customersAgentsDataModalReducer,
	customersAgentsDataModalAction,
} from "./dataModal";

export type StateAgents = {
	dataModal: customersAgentsDataModalState;
};

export const agents = combineReducers<StateAgents>({
	dataModal: customersAgentsDataModalReducer,
});

export const agentsAction = {
	dataModal: customersAgentsDataModalAction,
};

export default agents;
